import { mapState } from 'vuex';

import { Options } from '@/enums/options.enum';

// @vuese
// documentForm Mixin
export const documentFormMixin = {
  computed: {
    ...mapState({
      dictionary: state => {
        const dictionary = state.optionValue.options[Options.DICTIONARY].value;
        return dictionary && JSON.parse(dictionary);
      }
    }),

    data() {
      if (this.schema) {
        return this.schema.$model.data;
      }
      return this.document.data;
    }
  }
};
